import Vue from 'vue';
import Router from 'vue-router';
/*import Home from './components/Home.vue';
import AboutUs from './components/AboutUs.vue';
import ContactUs from './components/ContactUs.vue';
import Register from './components/Register.vue';*/
import Login from './components/Login.vue';

Vue.use(Router);

export const router = new Router({
  /*mode: 'history',*/
  routes: [
    /*{
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/home',
      component: Home
    },*/
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/login',
      component: Login
    },
    /*{
      path: '/register',
      component: Register
    },
    {
      path: '/aboutus',
      name: 'aboutUs',
      component: AboutUs
    },
    {
      path: '/contactus',
      name: 'contactUs',
      component: ContactUs
    },*/
    {
      path: '/dashboard',
      name: 'dashboard',
      // lazy-loaded
      component: () => import('./components/Dashboard.vue')
    },
    {
      path: '/profile',
      name: 'profile',
      // lazy-loaded
      component: () => import('./components/Profile.vue')
    },
    {
      path: '/superadmin',
      name: 'superAdmin',
      // lazy-loaded
      component: () => import('./components/BoardSuperAdmin.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      // lazy-loaded
      component: () => import('./components/BoardAdmin.vue')
    },
    {
      path: '/aud',
      name: 'auditor',
      // lazy-loaded
      component: () => import('./components/BoardAuditor.vue')
    },
    {
      path: '/man',
      name: 'manager',
      // lazy-loaded
      component: () => import('./components/BoardManager.vue')
    },
    {
      path: '/user',
      name: 'user',
      // lazy-loaded
      component: () => import('./components/BoardUser.vue')
    },
    {
      path: "/users",
      alias: "/users",
      name: "users",
      // lazy-loaded
      component: () => import("./components/UsersList")
    },
    {
      path: "/users/:id",
      name: "userDetails",
      // lazy-loaded
      component: () => import("./components/User")
    },
    {
      path: "/adduser",
      name: "addUser",
      // lazy-loaded
      component: () => import("./components/AddUser")
    },
    {
      path: "/changePassword/:id",
      name: "changePassword",
      // lazy-loaded
      component: () => import("./components/changePassword")
    },
    {
      path: "/countries",
      alias: "/countries",
      name: "countries",
      // lazy-loaded
      component: () => import("./components/CountriesList")
    },
    {
      path: "/countries/:id",
      name: "countryDetails",
      // lazy-loaded
      component: () => import("./components/Country")
    },
    {
      path: "/addcountry",
      name: "addCountry",
      // lazy-loaded
      component: () => import("./components/AddCountry")
    },
    {
      path: "/states",
      alias: "/states",
      name: "states",
      // lazy-loaded
      component: () => import("./components/StatesList")
    },
    {
      path: "/states/:id",
      name: "stateDetails",
      // lazy-loaded
      component: () => import("./components/State")
    },
    {
      path: "/addstate",
      name: "addState",
      // lazy-loaded
      component: () => import("./components/AddState")
    },
    {
      path: "/products",
      alias: "/products",
      name: "products",
      // lazy-loaded
      component: () => import("./components/ProductsList")
    },
    {
      path: "/products/:id",
      name: "productDetails",
      // lazy-loaded
      component: () => import("./components/Product")
    },
    {
      path: "/addproduct",
      name: "addProduct",
      // lazy-loaded
      component: () => import("./components/AddProduct")
    },
    {
      path: "/members",
      alias: "/members",
      name: "members",
      // lazy-loaded
      component: () => import("./components/MembersList")
    },
    {
      path: "/members/:id",
      name: "memberDetails",
      // lazy-loaded
      component: () => import("./components/Member")
    },
    {
      path: "/members/viewtree/:id",
      name: "memberTree",
      // lazy-loaded
      component: () => import("./components/Tree")
    },
    {
      path: "/movemember/:id",
      name: "moveMember",
      // lazy-loaded
      component: () => import("./components/MoveMember")
    },
    {
      path: "/accdata/:id",
      name: "accData",
      // lazy-loaded
      component: () => import("./components/AcctData")
    },
    {
      path: "/bonuslist/:id",
      name: "bonusList",
      // lazy-loaded
      component: () => import("./components/BonusList")
    },
    {
      path: "/addmember",
      name: "addMember",
      // lazy-loaded
      component: () => import("./components/AddMember")
    },
    {
      path: "/sales",
      alias: "/sales",
      name: "sales",
      // lazy-loaded
      component: () => import("./components/SalesList")
    },
    {
      path: "/sales/:id",
      name: "saleDetails",
      // lazy-loaded
      component: () => import("./components/Sale")
    },
    {
      path: "/addsale",
      name: "addSale",
      // lazy-loaded
      component: () => import("./components/AddSale")
    },
    {
      path: "/calculationboard",
      name: "calculationBoard",
      // lazy-loaded
      component: () => import("./components/CalculationBoard")
    },
    {
      path: "/bonuses",
      name: "allBonuses",
      // lazy-loaded
      component: () => import("./components/AllBonuses")
    },
    {
      path: "/filteredBonuses",
      name: "filteredBonuses",
      // lazy-loaded
      component: () => import("./components/FilteredBonuses")
    },
    {
      path: "/activations",
      name: "activations",
      // lazy-loaded
      component: () => import("./components/AllActivations")
    },
    {
      path: "/awards",
      name: "awards",
      // lazy-loaded
      component: () => import("./components/AllAwards")
    },
    {
      path: "/memberDownlines",
      name: "memberDownlines",
      // lazy-loaded
      component: () => import("./components/MemberDownlines")
    },
    {
      path: "/memberPurchases",
      name: "memberPurchases",
      // lazy-loaded
      component: () => import("./components/MemberPurchases")
    },
    {
      path: "/memberBonusReport",
      name: "memberBonusReport",
      // lazy-loaded
      component: () => import("./components/MemberBonusReport")
    },
    {
      path: "/auditLogs",
      alias: "/auditLogs",
      name: "auditLogs",
      // lazy-loaded
      component: () => import("./components/AuditLogsList")
    },
    {
      path: "/changeMemberPasswords",
      alias: "/changeMemberPasswords",
      name: "changeMemberPasswords",
      // lazy-loaded
      component: () => import("./components/ChangeMemberPasswords")
    }
  ]
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/aboutus', '/contactus', '/home'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
     next('/login');
  } else {
    next();
  }
});